import React, {forwardRef, useImperativeHandle, useRef} from 'react';
import {MenuItem} from "@mui/material";
import {useTranslation} from "react-i18next";

interface ImageFileUploaderProps {
    onFileSelect: (file: File | null) => void; // Callback to handle file selection
    allowVideo?: boolean; // Whether video uploads are permitted
}

export interface RefAttr {
    handleUploadClick: () => void;
}

const ImageFileUploader = forwardRef<RefAttr, ImageFileUploaderProps>
((props, ref) => {
    const {onFileSelect, allowVideo = false} = props;
    const fileInputRef = useRef<HTMLInputElement>(null);
    const {t} = useTranslation()

    console.log('[IMAGE FILE UPLOADER] allowVideo:', allowVideo)

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            onFileSelect(file); // Trigger the callback with the selected file
        } else {
            onFileSelect(null)
        }
        // Reset the input so picking the SAME file again still fires onChange
        // (the browser suppresses the event when the value is unchanged).
        event.target.value = '';
    };

    useImperativeHandle(ref, () => ({
        handleUploadClick: () => {
            fileInputRef.current?.click();
        }
    }));

    return (
        <>
            <input
                type="file"
                ref={fileInputRef}
                style={{display: 'none'}}
                accept={allowVideo ? "image/*,video/mp4,video/webm,video/quicktime" : "image/*"}
                onChange={handleFileChange}
            />
        </>
    );
});

export default ImageFileUploader;